import { useTranslation } from "@/shared/providers/LanguageProvider";

type ViewToggleProps = {
  view: BalanceView;
  onChange: (view: BalanceView) => void;
};

export function ViewToggle({ view, onChange }: ViewToggleProps) {
  const { t } = useTranslation();

  return (
    <div className="flex rounded-full bg-toggle-bg p-1">
      <button
        type="button"
        onClick={() => onChange("orders")}
        className={`rounded-full px-4 py-1.5 text-xs font-semibold transition-colors ${
          view === "orders"
            ? "bg-card text-foreground shadow-sm"
            : "text-muted"
        }`}
      >
        {t.common.orders}
      </button>
      <button
        type="button"
        onClick={() => onChange("expenses")}
        className={`rounded-full px-4 py-1.5 text-xs font-medium transition-colors ${
          view === "expenses"
            ? "bg-card text-foreground shadow-sm"
            : "text-muted"
        }`}
      >
        {t.common.expenses}
      </button>
    </div>
  );
}
